"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeCookie = exports.setCookie = exports.hasCookie = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const envDetector_1 = require("../../build-babel/utils/envDetector");
const init_1 = require("../../build-babel/form/init");
const COOKIE_COM_DOMAIN = '.hapag-lloyd.com';
const COOKIE_CN_DOMAIN = '.hapag-lloyd.cn';
const makeCookieName = baseUrl => {
  let env = (0, envDetector_1.getEnv)(baseUrl);
  if ('prod-china' === env) {
    env = 'prod';
  }
  if ('qa-china' === env) {
    env = 'qa';
  }
  if (env) {
    return `auth_${env}`;
  }
};
const hasCookie = baseUrl => {
  const cookieName = makeCookieName(baseUrl);
  return cookieName ? js_cookie_1.default.get(cookieName) !== undefined : false;
};
exports.hasCookie = hasCookie;
const setCookie = (value, baseUrl) => {
  const cookieName = makeCookieName(baseUrl);
  cookieName && js_cookie_1.default.set(cookieName, value, {
    domain: (0, init_1.isChineseDomain)() ? COOKIE_CN_DOMAIN : COOKIE_COM_DOMAIN
  });
};
exports.setCookie = setCookie;
const removeCookie = baseUrl => {
  const cookieName = makeCookieName(baseUrl);
  cookieName && js_cookie_1.default.remove(cookieName, {
    domain: (0, init_1.isChineseDomain)() ? COOKIE_CN_DOMAIN : COOKIE_COM_DOMAIN
  });
};
exports.removeCookie = removeCookie;
//# sourceMappingURL=cookie.js.map